import type { PackageType } from "./admin-orders-shared";

export const PACKAGE_LABELS: Record<PackageType, string> = {
  LANDING_PAGE: "Landing Page",
  BRAND_PACKAGE: "Branding Package",
  BASIC_MVP: "Basic MVP",
  ADVANCED_MVP: "Advanced MVP",
};
